import { render, staticRenderFns } from "./EsgDisclosureTemplateList.vue?vue&type=template&id=37adf1f8"
import script from "./EsgDisclosureTemplateList.vue?vue&type=script&lang=js"
export * from "./EsgDisclosureTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports